/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React, { useEffect } from 'react';

import { getItem, LS_KEYS, setItem } from 'utils/localStorage';

import AppRouting from './Routing/AppRouting';
import { useCheckAuthentication, useCheckConnection } from './hooks';

export function App() {
  useCheckAuthentication();
  useCheckConnection();

  useEffect(() => {
    const showNetworkErrorModal = getItem(LS_KEYS.showNetworkErrorModal);
    if (!showNetworkErrorModal) {
      setItem(LS_KEYS.showNetworkErrorModal, 'true');
    }
  }, []);

  return <AppRouting />;
}
